import axios from "@/utils/axios.js";

/**
 * 获取推荐楼盘列表
 */
export async function getRecomBuildings(cityId) {
  // /houses/housesMessageView/
  // new: /houses/housesMessageViewByCityD
  let url = `/houses/housesMessageViewByCityD/${encodeURIComponent(cityId)}`;
  return axios.get(url);
}
